import { useGetTotemsFilterQuery, TotemState } from 'data/__generated__';

import { DataTable } from 'components/DataTable';

import { totemsColumns, type TotemRow, type TotemFilterInput } from '../constants/totemsColumns';

const defaultFilters: TotemFilterInput = {
    searchValue: '',
    state: [TotemState.Rollout],
};

export const TotemsList = () => {
    const { loading, data, error, refetch, fetchMore } = useGetTotemsFilterQuery({
        fetchPolicy: 'cache-and-network',
        notifyOnNetworkStatusChange: true,
        variables: { filters: defaultFilters },
    });

    if (error) {
        throw new Error('Une erreur est survenue lors de la récupération des totems');
    }

    const hasMore = data?.totemsFilter.hasMore ?? false;
    const totems = data?.totemsFilter.totems ?? [];

    return (
        <div className="flex h-full w-full flex-col overflow-hidden">
            <DataTable<TotemRow, TotemFilterInput>
                columns={totemsColumns}
                data={totems}
                filterMode="server"
                getRowId={(row) => row._id}
                getRowLink={(row) => `/totem/${row._id}`}
                hasMore={hasMore}
                isLoading={loading}
                refetch={async (vars) => {
                    await refetch({ ...vars });
                }}
                fetchMore={async (opts) => {
                    await fetchMore({ variables: opts.variables });
                }}
                defaultFilters={defaultFilters}
                searchPlaceholder="Nom du totem, organisation, site"
                searchFilterKey="searchValue"
            />
        </div>
    );
};
